import * as React from 'react';
export var SelectContext = /*#__PURE__*/React.createContext(null);